// @ts-nocheck
import {
  Autocomplete,
  Checkbox,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import { getCssVariableHandler } from "../../../../../utils/styles/getCssVariables";
import LineClamp from "../../../../positions/components/LineClamp";
import { Close } from "@mui/icons-material";
import GenericTransparentBtn from "../../../../../components/Custom/GenericTransparentBtn";

export default function SheetFilterDropdown({
  options,
  setValue,
  value = [],
  placeholder,
  valueText,
  style,
  onClear,
}) {
  const [inputValue, setInputValue] = useState("");
  const [open, setOpen] = useState(false);

  const handleClear = () => {
    setValue([]);
  };

  return (
    <Autocomplete
      multiple
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      style={{
        minWidth: style?.minWidth || "250px",
        width: "100%",
      }}
      className="coordinator-search"
      onChange={(_, newValue) => setValue(newValue)}
      options={options}
      value={value}
      autoHighlight
      disableCloseOnSelect
      onInputChange={(_, newValue) => setInputValue(newValue)}
      inputValue={inputValue}
      ListboxProps={{ className: "custom-scroll-design" }}
      getOptionLabel={(option) => option?.name}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      renderTags={() => null}
      noOptionsText={
        <Typography sx={{ color: "white" }}>No options</Typography>
      }
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params?.InputProps,
            endAdornment:
              value?.length > 0 ? (
                <GenericTransparentBtn
                  onClick={() => {
                    if (onClear) {
                      onClear();
                    }
                  }}
                  style={{
                    background: "grey",
                    padding: "0.10rem",
                    marginRight: "0.5rem",
                    borderRadius: "50%",
                    onHover: {
                      background: "grey",
                      padding: "0.10rem",
                    },
                  }}
                >
                  <Close
                    sx={{
                      fontSize: "1rem",
                      // marginRight: "0.7rem"
                    }}
                  />
                </GenericTransparentBtn>
              ) : (
                params?.InputProps?.endAdornment
              ),
              // <IconButton
              //   sx={{
              //     paddingTop: "0 !important",
              //     paddingBottom: "0 !important"
              //   }}
              //   onClick={() => {
              //     if (onClear) {
              //       onClear();
              //     }
              //   }}
              // >
              //   <Clear />
              // </IconButton>
          }}
          placeholder={
            value.length > 0 ? `${valueText} (${value?.length})` : placeholder
          }
          onChange={(e) => setInputValue(e.target.value)} // Ensure input updates
          sx={{
            fontSize: "0.8rem",
            height: "3rem",
            backgroundColor: "black",
            borderRadius: "0.5rem",
            border: "1px solid",
            borderColor: getCssVariableHandler({
              variableName: "--primary-pink-hex",
            }),
            "& .MuiInputBase-input::placeholder": {
              color: "text.main",
              opacity: 1,
            },
            "& .MuiOutlinedInput-root": {
              padding: "0 !important",
              paddingTop: "0.25rem !important",
            },
            "& fieldset": {
              border: "none",
            },
          }}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <Grid
          key={option?.value}
          container
          alignItems="center"
          sx={{
            border: "1px solid #D175B6",
            borderRadius: "4px",
            backgroundColor: "#000",
            color: "white",
            paddingX: "0.25rem !important",
            paddingY: "0.25rem !important",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            whiteSpace: "nowrap",
          }}
          {...props}
        >
          <Checkbox
            checked={selected}
            sx={{
              color: "#D175B6",
              "&.Mui-checked": { color: "#D175B6" },
              padding: "4px",
            }}
          />
          <Typography sx={{ color: "white", fontSize: "14px" }}>
            <LineClamp text={option?.name} maxLines={1} />
          </Typography>
        </Grid>
      )}
      PaperComponent={({ children }) => (
        <Paper
          sx={{
            backgroundColor: "#000",
            borderRadius: "4px",
            border: "1px solid #D175B6",
            zIndex: 20,
            width: "250px",
            padding: "5px 8px",
            color: "white",
            whiteSpace: "nowrap",
            margin: "auto",
          }}
        >
          {children}
        </Paper>
      )}
    />
  );
}

SheetFilterDropdown.propTypes = {
  options: PropTypes.array.isRequired,
  setValue: PropTypes.func.isRequired,
  value: PropTypes.array,
  placeholder: PropTypes.string,
  valueText: PropTypes.string,
  style: PropTypes.object,
  onClear: PropTypes.any,
};